import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../primaryComponents";
import secondaryComponents from "../../..";
import { defaultDateDisplay, formatCurrency } from "../../../../../helpers";
import { TimesCircle } from "../../../../../assets/svgIcons";
import styles from "../CardListener/styles.module.scss";
import { useTransferListener } from "./useTransferListener";
import { TransferLinkConfirmation } from "../TransferLinkConfirmation";
import { RoutedModal } from "../../../../common";

export const TransferListener = ({
  amount = 0,
  paymentProvider,
  closeModal = () => {},
}) => {
  const {
    isLoading,
    terminalDetails,
    transactions,
    selectedTnx,
    isCreatingOrder,
    setSelectedTnx,
    handleLinkTransaction,
  } = useTransferListener({
    amount,
    paymentProvider,
    closeModal,
  });

  return (
    <>
      <div>
        <div className={styles.routedModal__header}>
          <h4 className="mb-0">Accept Transfer Payments</h4>

          <primaryComponents.Button
            classNames={"btn btn--outline-red"}
            onClick={() => {
              closeModal();
            }}
          >
            Cancel Payment
          </primaryComponents.Button>
        </div>

        <div className="text-center">
          <div className="my-4">
            <p>Amount</p>
            <h3>{formatCurrency({ value: amount })}</h3>
          </div>

          {terminalDetails ? (
            <div
              className={`${globalStyles.cardWithBorder}`}
              style={{ minHeight: "150px" }}
            >
              <div className={`${globalStyles.cardWithBackground} py-4`}>
                <h4 className="gray--text font-weight-normal mb-0">
                  Account Number:{" "}
                  <span className="purple--text">
                    {terminalDetails?.account_number}
                  </span>
                </h4>
                <p>
                  Account Name:{" "}
                  <span className="dark--text">
                    {terminalDetails?.account_name}
                  </span>
                </p>
                <p>
                  Bank Name:{" "}
                  <span className="dark--text">
                    {terminalDetails?.bank_name}
                  </span>
                </p>

                <secondaryComponents.LoaderHelper
                  classNames={"mt-4"}
                  isLoading={true}
                ></secondaryComponents.LoaderHelper>
                <p className="smallest-text-size">Listening for transfer</p>
              </div>

              <secondaryComponents.LoaderHelper
                isLoading={isLoading}
                classNames={"mt-4"}
              >
                <div
                  className={`mt-4 ${globalStyles.pageColumnGaps}`}
                  style={{ gap: "5px" }}
                >
                  {transactions?.length > 0 ? (
                    <>
                      {transactions?.map((transaction) => (
                        <div
                          className={`${globalStyles.cardWithBackground} ${styles.tnxCard}`}
                          key={transaction?.id}
                          onClick={() => setSelectedTnx(transaction)}
                        >
                          <div>
                            <h5 className="mb-0">{transaction?.payer}</h5>

                            <p className="dark--text">
                              <span className="gray--text">Tnx ID:</span>{" "}
                              {transaction?.id} |{" "}
                              {transaction?.payer_bank || "N/A"}
                            </p>
                          </div>

                          <div className="text-right">
                            <h5 className="success--text mb-0">
                              {formatCurrency({ value: transaction?.amount })}
                            </h5>
                            <p className="smallest-text-size">
                              {defaultDateDisplay(transaction?.created_at)}
                            </p>
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className={`${globalStyles.cardWithBorder}`}>
                      <h5 className="py-5">No Unmapped Transfers Received</h5>
                    </div>
                  )}
                </div>
              </secondaryComponents.LoaderHelper>
            </div>
          ) : (
            <div className="mt-5">
              <TimesCircle
                className="error--text"
                style={{ fontSize: "50px" }}
              />
              <h4 className="font-weight-normal">
                Please assign a terminal to this device to procced with transfer
              </h4>
            </div>
          )}
        </div>

        <RoutedModal
          isActive={selectedTnx !== null}
          closeModal={() => setSelectedTnx(null)}
          width={550}
          style={{ height: "auto" }}
          headerTitle="Confirm Transaction"
        >
          <TransferLinkConfirmation
            closeModal={() => setSelectedTnx(null)}
            transactionDetails={selectedTnx}
            isLoading={isCreatingOrder}
            proceed={handleLinkTransaction}
          />
        </RoutedModal>
      </div>
    </>
  );
};
